import React from 'react';
import PropTypes from 'prop-types';
import {
  Field,
  reduxForm
} from 'redux-form';
import {
  BackToSignInButton,
  ErrorMessage,
  SubmitButton,
  TextField
} from '../components';

const validate = values => {
  const errors = {}

  if (!values.password) {
    errors.password = 'Required'
  } else if (values.password.length <= 5) {
    errors.password = 'Password must be more than 5 characters long';
  } else if (values.password.length >= 100) {
    errors.password = 'Password must be less than 100 characters long';
  }

  if (!values.code) {
    errors.code = 'Required';
  } else if (values.code.length !== 6) {
    errors.code = 'Code must be 6 numbers';
  }

  return errors
};

const UpdatePasswordForm = ({
  handleSubmit,
  changeState,
  errorMessage = false,
  working = false
}) => {
  return (
    <form
      className="forgot-password auth__form"
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <div className="auth--form-group">
        <Field
          name="code"
          component={TextField}
          label="Code"
          type="code"
          props={{
            disabled: working
          }}
        />
      </div>
      <div className="auth--form-group">
        <Field
          name="password"
          component={TextField}
          label="Password"
          type="password"
          props={{
            disabled: working
          }}
        />
      </div>
      <SubmitButton
        busy={working}
        textOnBusy="Updating Password"
        textOnIdle="Update Password"
      />
      <ErrorMessage errorMessage={errorMessage} />
      <BackToSignInButton changeState={changeState} />
    </form>
  )
};

UpdatePasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  changeState: PropTypes.func.isRequired,
  errorMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]).isRequired,
  working: PropTypes.bool.isRequired,
};

export default reduxForm({
  form: 'auth/forgot-password/update',
  validate
})(UpdatePasswordForm);


// WEBPACK FOOTER //
// ./src/components/Authentication/ForgotPassword/UpdatePasswordForm.js